<div class="container">
    <div class="row header">
        <smart-icon name="filter-o" class="light filter-icon"></smart-icon>
        <span class="h3-regular ed-filter-title">FILTER YOUR DATA</span>
    </div>
    <div class="row">
        <label class="ck-latest-notes" tam-checkbox [(ngModel)]="config.needFilterByLatestExecutionTime">
            <span class="body-2">Only include notes submitted since the last email</span>
        </label>
        <label *ngIf="isNoteSection" tam-checkbox [(ngModel)]="config.isIncludeEvents">
            <span class="body-2">Check to include calendar events</span>
        </label>
    </div>
    <div class="row">
        <tam-field-selector [config]="fieldConfig">
            <ng-template #customBtn>
                <span class="add-filter-btn">+ Add Filter</span>
            </ng-template>
        </tam-field-selector>
    </div>
    <filter-panel [config]="filterConfig"></filter-panel>
</div>